import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { stringify } from 'qs'

import listeningPNG from '../../assets/listening.png'
import readingPNG from '../../assets/reading.png'
import { actions as appActions } from '../../store/app'
import { changeScoreArray, isHarmony, isVLD } from '../../utils/utils'
import ScoreItem from '../../components/ScoreItem'
import Loading from '../../components/Loading'
import { uploadResult, reportEvent } from '../../services/api'
import { globalShare, exit, setShareState } from '../../services/native'
import styles from './index.module.css'

const shareUrl = 'https://vocabulary.baicizhan.com/new_vocabulary/index.html?'

export default function Result() {
  const { testType, trace } = useSelector((state) => state.app)
  const { runtime, count } = useSelector((state) => state.test)
  const { subject, banners, isLoaded } = useSelector((state) => state.result)
  const { score = 9527 } = runtime || {}
  const dispatch = useDispatch()

  useEffect(() => {
    setShareState(true)
  }, [])

  useEffect(() => {
    let shareTitle = ''
    if (testType === 2) {
      shareTitle = '我的听力词汇量在' + score + '个左右'
    } else {
      shareTitle = '我的阅读词汇量在' + score + '个左右'
    }
    globalShare({
      url:
        shareUrl +
        stringify({
          type: testType === 2 ? 'listening' : 'reading',
          trace: 'share',
        }),
      title: shareTitle || document.title,
      desc: subject,
      img: 'https://7n.bczcdn.com/static/logo512.png',
    })
    // eslint-disable-next-line
  }, [score])

  useEffect(() => {
    reportEvent({
      stat_group: 'vocabulary-common',
      event_id: 'visited_result_page',
      extra_info: JSON.stringify({
        type: testType === 2 ? 'listening' : 'reading',
        trace,
        score,
      }),
    })
    uploadResult({ testType, score, count })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (banners.length > 0) {
      reportEvent({
        stat_group: 'vocabulary-common',
        event_id: 'expose_result_banner',
        extra_info: JSON.stringify({
          ids: banners.map((item) => item.id),
          adv_ids: banners.map((item) => item.id),
        }),
      })
    }
  }, [banners])

  const handleRetry = () => {
    reportEvent({
      stat_group: 'vocabulary-common',
      event_id: 'click_retry_test',
      extra_info: JSON.stringify({
        type: testType === 2 ? 'listening' : 'reading',
        trace,
        score,
      }),
    })
    dispatch(appActions.createPreTest(testType))
  }

  const handleGoBack = () => {
    setShareState(false)
    const goBack = () => {
      if (
        isVLD ||
        trace === 'popup' ||
        trace === 'oldmine' ||
        trace === 'profile'
      ) {
        exit().catch((err) => console.log(err))
      } else {
        history.back()
      }
    }
    reportEvent({
      stat_group: 'vocabulary-common',
      event_id: 'click_go_back',
      extra_info: JSON.stringify({
        type: testType === 2 ? 'listening' : 'reading',
        trace,
        score,
      }),
    }).then(goBack, goBack)
  }

  const handleLinkClick = (id, url) => {
    setShareState(false)
    const go = () => {
      window.location.replace(url)
    }
    reportEvent({
      stat_group: 'vocabulary-common',
      event_id: 'click_img_ad',
      extra_info: JSON.stringify({
        type: testType === 2 ? 'listening' : 'reading',
        trace,
        id,
        adv_id: id,
        score,
      }),
    }).then(go, go)
  }

  const scoreArr = Array.from(changeScoreArray(score))

  if (!isLoaded) return <Loading />
  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.header}>
          <img src={testType === 2 ? listeningPNG : readingPNG} alt='' />
          <span>{testType === 2 ? '听力词汇量' : '阅读词汇量'}</span>
        </div>
        <div className={styles.score}>
          {scoreArr.map((digit, idx) => (
            <ScoreItem
              key={idx}
              digit={digit}
              delay={(scoreArr.length - idx - 1) * 0.5}
            />
          ))}
        </div>
        <div className={styles.subject}>{subject}</div>
        {banners.map((banner) => (
          <div
            className={styles.link}
            key={banner.id}
            href={banner.jump_url}
            onClick={() => handleLinkClick(banner.id, banner.jump_url)}
          >
            <img src={banner.img} alt='' />
          </div>
        ))}
      </div>
      <div className={styles.retryBtn} onClick={handleRetry}>
        重新测试
      </div>
      {trace !== 'share' && (
        <div className={styles.backBtn} onClick={handleGoBack}>
          返回
        </div>
      )}

      {isHarmony && <div className='safe-bottom'></div>}
    </div>
  )
}
